import React, { useEffect, useRef } from 'react';
import { View, StyleSheet } from 'react-native';
import { styles } from '../styles';
import { useTheme } from '../theme';

let timMessengerElement: HTMLElement | null = null;
let scriptsLoaded = false;

export function MessagesView() {
  const containerRef = useRef<HTMLDivElement>(null);
  const { theme } = useTheme();

  const themeAttr = JSON.stringify({
    mode: 'dark',
    dark: {
      primary: theme.timPrimary,
      secondary: theme.timSecondary,
    },
  });

  useEffect(() => {
    if (timMessengerElement) {
      timMessengerElement.setAttribute('theme', themeAttr);
    }
  }, [themeAttr]);

  useEffect(() => {
    if (!containerRef.current) return;
    if (timMessengerElement) {
      timMessengerElement.setAttribute('theme', themeAttr);
      containerRef.current.appendChild(timMessengerElement);
      return;
    }
    if (scriptsLoaded) return;

    (window as any).process = { env: {} };
    (window as any).OLM_OPTIONS = {
      locateFile: (file: string) => `/${file}`
    };

    const olmScript = document.createElement('script');
    olmScript.src = '/olm.js';

    olmScript.onload = () => {
      const timScript = document.createElement('script');
      timScript.type = 'module';
      timScript.src = '/tim-embed/dist/tim-messenger.es.js';

      timScript.onload = () => {
        scriptsLoaded = true;
        const el = document.createElement('tim-messenger');
        el.setAttribute('theme', themeAttr);
        el.style.width = '100%';
        el.style.height = '100%';
        timMessengerElement = el;
        containerRef.current?.appendChild(el);
      };

      document.head.appendChild(timScript);
    };

    document.head.appendChild(olmScript);
  }, []);

  return (
    <View style={{ ...styles.contentContainer, padding: 0 }}>
      <div ref={containerRef as any} style={timStyles.container} />
    </View>
  );
}

const timStyles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 0,
    margin: 0,
  },
});
